import { WorkflowExecutionStepDetailsDTO } from 'interfaces/workflowExecutions/workflowExecutionStepDetails'
import { WorkflowExecutionStepStatus } from 'interfaces/workflowExecutions/workflowExecutionStepStatus'

export function getIsWorkflowExecutionStepSuccess(workflowStep?: WorkflowExecutionStepDetailsDTO | null) {
  return workflowStep?.status === WorkflowExecutionStepStatus.SUCCESS
}
